import React from 'react';
import {ShowToastPayloadMap, TOAST_CONTENT_TYPE} from '../../redux/actions/toast.actions';
import DefaultToastItem from './default-toast-item/DefaultToastItem';
import PostPurchaseToastItemContainer from './post-purchase-toast-item/postPurchaseToastItem.container';

interface ToastItemProps {
    content: ShowToastPayloadMap;
    dismissToastItem: (id: number) => void;
    id: number;
}

const ToastItem = ({content, dismissToastItem, id}: ToastItemProps) => {
    const messages = content.get('messages');

    const type: TOAST_CONTENT_TYPE = content.get('type');
    if (type === TOAST_CONTENT_TYPE['POST_PURCHASE']) {
        return (
            <PostPurchaseToastItemContainer
                data={content.get('postPurchaseData')}
                dismissToastItem={dismissToastItem}
                id={id}
            />
        );
    }

    return (
        <DefaultToastItem
            avatar={content.get('avatar')}
            dismissToast={dismissToastItem}
            icon={content.get('icon')}
            id={id}
            isError={content.get('isError')}
            text={content.get('text')}
            messages={messages && messages.toJS()}
        />
    );
};

export default ToastItem;
